/* GB Custom Bundle Box controller v2 (viewport selector fix 2026-07-13).
   Adds: Buy-1 color slot, CHANGE BLASTER button, full-screen filterable modal
   (category chips from product types + bestsellers + price sort), image-fallback
   swatch dots, sticky-ATC scroll gating, modal scroll-lock above the sticky bar.
   Two-phase ATC unchanged: extras pre-add via /cart/add.js?kaching_bundles=true,
   then native form submit replay (native drawer render + open). Checkout pricing
   is enforced by the native automatic discounts (SAVE 55% / SAVE 60%). */
(function () {
  'use strict';
  if (window.__gbbInit) return; window.__gbbInit = true;

  /* Buy 2 "Free Shipping" label (2026-09-24). Pure check: same threshold conversion as the gbfs cart bar
     (assets/gb-free-shipping.js: Math.round(base * Shopify.currency.rate)). The base comes from the snippet
     constant gbb_freeship_base_cents (cfg.freeShipBaseCents). Missing base or rate = never show. */
  function gbbFreeShipQualifies(totalCents, baseCents, rate) {
    var base = Number(baseCents), r = Number(rate);
    if (!(base > 0) || !(r > 0)) return false;
    return Math.floor(Number(totalCents) || 0) >= Math.round(base * r);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Multi-instance registry: the widget can be injected repeatedly (PDP + every
  // collection quick-view). Each [data-gbb] root gets its own bound instance; the
  // single document-level submit interceptor routes a form to the instance whose
  // container holds it.
  var instances = [];

  function initWidget(root) {
    if (root.__gbbBound) return;
    root.__gbbBound = true;
    var dataEl = root.parentNode ? root.parentNode.querySelector('script[data-gbb-data]') : null;
    if (!dataEl) return;
    var container = root.closest('quick-add-modal, .quick-add-modal, dialog, .shopify-section') || document.body;

    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var byId = {};
    (cfg.products || []).forEach(function (p) { byId[p.id] = p; });
    var host = byId[cfg.hostId];
    if (!host) return;

    /* ---------- money formatting (derived from a Liquid-localized sample) ---------- */
    var fmt = (function (sample) {
      var m = sample.match(/[\d.,\s  ']*\d/);
      var num = m ? m[0] : '1,234.56';
      var idx = sample.indexOf(num);
      var pre = sample.slice(0, idx), suf = sample.slice(idx + num.length);
      var decSep = '.', thoSep = ',', decimals = 2;
      var c = num.length >= 3 ? num.charAt(num.length - 3) : '';
      if (c && /[^\d]/.test(c)) {
        decSep = c;
        var rest = num.slice(0, num.length - 3).replace(/\d/g, '');
        thoSep = rest ? rest.charAt(rest.length - 1) : (decSep === '.' ? ',' : '.');
      } else { decimals = 0; thoSep = (num.replace(/\d/g, '') || ',').charAt(0); }
      return function (cents) {
        var n = (cents / 100).toFixed(decimals);
        var parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thoSep);
        return pre + (decimals ? parts[0] + decSep + parts[1] : parts[0]) + suf;
      };
    })(cfg.moneySample || '$1,234.56');

    /* ---------- state ---------- */
    var state = {
      tier: 1,                                    // preselected: Buy 2
      qty: 3,                                     // Buy 3+ stepper value
      slots: { 1: [null], 2: [null, null] },      // per-tier extra slots; null = follow host
      hostVid: cfg.hostVariantId,
      filter: 'all',                              // 'all' | 'bs' | <product type>
      sort: ''                                    // '' | 'asc' | 'desc'
    };

    function mainForm() {
      return container.querySelector('form[id="product-form-' + cfg.sectionId + '"]') ||
        container.querySelector('product-form form[data-type="add-to-cart-form"]');
    }
    function readHostVid() {
      var f = mainForm();
      if (f) {
        var inp = f.querySelector('input[name="id"], select[name="id"]');
        if (inp && inp.value) state.hostVid = Number(inp.value);
      }
      return state.hostVid;
    }

    function findVariant(p, vid) {
      for (var i = 0; i < p.vs.length; i++) if (p.vs[i].id === vid) return p.vs[i];
      return p.vs[0];
    }
    function slotResolved(slot) {
      if (!slot) { var v = findVariant(host, readHostVid()); return { p: host, v: v }; }
      var p = byId[slot.pid] || host;
      return { p: p, v: findVariant(p, slot.vid) };
    }
    function tierUnits() {
      var t = cfg.tiers[state.tier];
      if (!t) return 1;
      return t.plus ? state.qty : t.qty;
    }
    function discPct() { return (cfg.tiers[state.tier] || {}).disc || 0; }
    function unitPrice(cents, disc) { return Math.round(cents * (100 - disc) / 100); }
    function ordinal(n) { return n === 2 ? '2nd' : n === 3 ? '3rd' : n + 'th'; }
    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* swatch dot: mapped color name, else the variant image itself (always accurate) */
    function dotStyle(v) {
      var hex = cfg.swatches[v.c];
      if (hex) return 'background:' + hex;
      return 'background-image:url(' + v.img + ')';
    }
    function colorChip(v, caret) {
      return '<span class="gbb-dot" style="' + dotStyle(v) + '"></span>' +
        '<span class="gbb-chip-label">' + esc(v.c) + '</span>' + (caret ? '<span class="gbb-car">&#9660;</span>' : '');
    }

    /* ---------- bars / slots rendering ---------- */
    var bars = [].slice.call(root.querySelectorAll('[data-gbb-bar]'));

    function syncSlotCount() {
      if (state.tier === 0) return;
      var extras = tierUnits() - 1;
      var arr = state.slots[state.tier] || [];
      while (arr.length < extras) arr.push(null);
      arr.length = extras;
      state.slots[state.tier] = arr;
    }

    function tierTotals(tierIndex) {
      var hv = findVariant(host, readHostVid());
      var t = cfg.tiers[tierIndex] || { qty: 1, disc: 0 };
      var qty = t.plus && tierIndex === state.tier ? state.qty : (t.qty || 1);
      var slots = state.slots[tierIndex] || [];
      var sum = hv.p, cmp = hv.cp || hv.p;
      for (var i = 0; i < qty - 1; i++) {
        var r = slotResolved(slots[i] || null);
        sum += r.v.p;
        cmp += (r.v.cp || r.v.p);
      }
      return { price: unitPrice(sum, t.disc || 0), compare: cmp };
    }

    function clubFactor() {
      try {
        var scope = (root.closest && (root.closest('.product__info-container,.main-product__info-container') || root.closest('quick-add-modal'))) || null;
        var cb = (scope && scope.querySelector('[data-gb-membership] .gb-check')) || document.querySelector('[data-gb-membership] .gb-check');
        return cb && cb.checked ? 0.95 : 1;
      } catch (e) { return 1; }
    }
    function renderPrices() {
      var hv = findVariant(host, readHostVid());
      var mf = clubFactor();
      bars.forEach(function (bar, i) {
        var disc = Number(bar.getAttribute('data-disc')) || 0;
        var pEl = bar.querySelector('[data-gbb-price]');
        var cEl = bar.querySelector('[data-gbb-cmp]');
        var totals = cfg.variantBundle ? tierTotals(i) : null;
        if (pEl) pEl.textContent = fmt(Math.round((totals ? totals.price : unitPrice(hv.p, disc)) * mf));
        if (cEl) cEl.textContent = fmt(totals ? totals.compare : (hv.cp || hv.p));
      });
      try { renderFreeShip(); } catch (e) {}
    }
    /* Buy 2 total as the widget computes it: host + chosen Buy 2 slot, tier discount, then Club factor. */
    function buy2TotalCents() {
      return Math.floor(tierTotals(1).price * clubFactor());
    }
    function renderFreeShip() {
      var el = bars[1] && bars[1].querySelector('[data-gbb-fs]');
      if (!el) return;
      var cur = (window.Shopify && window.Shopify.currency) || {};
      var rate = Number(cur.rate) || (cfg.shopCurrency ? 1 : 0);
      var q = gbbFreeShipQualifies(buy2TotalCents(), cfg.freeShipBaseCents, rate);
      if (el.hidden === q) el.hidden = !q;
    }
    document.addEventListener('gb-club:toggle', function () { try { renderPrices(); } catch (e) {} });

    function slotRowHtml(res, slotIdx, withChange, label) {
      var slotName = cfg.variantBundle ? 'Bundle ' + (slotIdx + 1) : res.p.t;
      return '<div class="gbb-slot" data-slot="' + slotIdx + '">' +
        '<img class="gbb-slot-img" src="' + res.v.img + '" alt="" decoding="async">' +
        '<div class="gbb-slot-info"><span class="gbb-slot-name">' + esc(slotName) + '</span>' +
        (res.p.vs.length > 1
          ? '<span class="gbb-pop"><button type="button" class="gbb-chip" data-gbb-color="' + slotIdx + '">' + colorChip(res.v, true) + '</button></span>'
          : '') +
        '</div>' +
        (withChange
          ? '<div class="gbb-slot-actions"><button type="button" class="gbb-choose" data-gbb-open="' + slotIdx + '">' + label + '</button></div>'
          : '') +
        '</div>';
    }

    function renderSlots() {
      var bar = bars[state.tier];
      if (!bar) return;
      var wrap = bar.querySelector('[data-gbb-slots]');
      if (!wrap) return;
      syncSlotCount();
      var hv = findVariant(host, readHostVid());
      var html = slotRowHtml({ p: host, v: hv }, 0, false, '');
      (state.slots[state.tier] || []).forEach(function (slot, i) {
        var r = slotResolved(slot);
        html += slotRowHtml(r, i + 1, !cfg.variantBundle, '&#8644; CHANGE<small>BLASTER</small>');
      });
      if (wrap.__gbbLast !== html) {
        wrap.innerHTML = html;
        wrap.__gbbLast = html;
      }
      renderTotal();
    }

    function renderTotal() {
      var bar = bars[state.tier];
      if (!bar) return;
      var el = bar.querySelector('[data-gbb-total]');
      if (!el) return;
      el.hidden = true;
      el.style.display = 'none';
      el.innerHTML = '';
    }

    function renderTier() {
      bars.forEach(function (bar, i) {
        var on = i === state.tier;
        bar.classList.toggle('on', on);
        bar.setAttribute('aria-checked', on ? 'true' : 'false');
        var ex = bar.querySelector('[data-gbb-expand]');
        if (ex) ex.hidden = !on;
      });
      var qEl = root.querySelector('[data-gbb-qty]');
      if (qEl) qEl.textContent = state.qty;
      renderPrices();
      renderSlots();
    }

    /* ---------- native variant picker sync ---------- */
    function nativePicker() {
      return container.querySelector('variant-selects[data-section="' + cfg.sectionId + '"], variant-radios[data-section="' + cfg.sectionId + '"]');
    }
    function setNativeVariant(v) {
      var np = nativePicker();
      if (!np) return;
      var parts = v.c.split(' / ');
      var selects = np.querySelectorAll('select');
      if (selects.length) {
        selects.forEach(function (sel, i) { if (parts[i] != null) sel.value = parts[i]; });
        selects[0].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var radios = np.querySelectorAll('input[type="radio"]');
      radios.forEach(function (r) { if (parts.indexOf(r.value) > -1 && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } });
    }

    /* ---------- color popover ---------- */
    function closePops() {
      [].slice.call(document.querySelectorAll('.gbb-pop-list')).forEach(function (n) {
        if (n.__gbbCleanup) n.__gbbCleanup();
        n.remove();
      });
    }
    function popViewport() {
      var vv = window.visualViewport;
      return {
        top: vv ? vv.offsetTop : 0,
        left: vv ? vv.offsetLeft : 0,
        width: vv ? vv.width : (document.documentElement.clientWidth || window.innerWidth),
        height: vv ? vv.height : window.innerHeight
      };
    }
    function popLayout(rect, viewport, naturalHeight) {
      var edge = 8, gap = 6;
      var viewTop = viewport.top + edge;
      var viewLeft = viewport.left + edge;
      var viewRight = viewport.left + viewport.width - edge;
      var viewBottom = viewport.top + viewport.height - edge;
      var anchorTop = rect.top + viewport.top;
      var anchorBottom = rect.bottom + viewport.top;
      var width = Math.min(Math.max(180, rect.width), Math.max(0, viewport.width - (edge * 2)));
      var left = Math.max(viewLeft, Math.min(rect.left + viewport.left, viewRight - width));
      var above = Math.max(0, anchorTop - gap - viewTop);
      var below = Math.max(0, viewBottom - anchorBottom - gap);
      var opensUp = above >= naturalHeight || (below < naturalHeight && above > below);
      var space = opensUp ? above : below;
      var maxHeight = Math.max(0, Math.floor(space));
      var height = Math.min(naturalHeight, maxHeight);
      var top = opensUp ? anchorTop - gap - height : anchorBottom + gap;

      if (maxHeight < 48) {
        maxHeight = Math.max(0, Math.floor(viewBottom - viewTop));
        height = Math.min(naturalHeight, maxHeight);
        top = viewTop;
      }
      top = Math.max(viewTop, Math.min(top, viewBottom - height));
      return { top: top, left: left, width: width, maxHeight: maxHeight, opensUp: opensUp };
    }
    function positionPop(list, anchor) {
      var viewport = popViewport();
      var rect = anchor.getBoundingClientRect();
      var firstPass = popLayout(rect, viewport, 9999);
      list.style.width = Math.round(firstPass.width) + 'px';
      var layout = popLayout(rect, viewport, list.scrollHeight);
      list.style.top = Math.round(layout.top) + 'px';
      list.style.left = Math.round(layout.left) + 'px';
      list.style.maxHeight = Math.round(layout.maxHeight) + 'px';
      list.classList.toggle('up', layout.opensUp);
      list.style.visibility = 'visible';
    }
    function popFor(anchor, p, curVid, onPick) {
      closePops();
      p.vs.forEach(function (v) { if (v.img) { var im = new Image(); im.src = v.img; } });
      var list = document.createElement('div');
      list.className = 'gbb-pop-list';
      list.style.visibility = 'hidden';
      list.innerHTML = p.vs.map(function (v) {
        return '<button type="button" class="gbb-pop-item' + (v.id === curVid ? ' on' : '') + '" data-vid="' + v.id + '">' +
          '<span class="gbb-dot" style="' + dotStyle(v) + '"></span>' + esc(v.c) + '</button>';
      }).join('');
      list.addEventListener('click', function (e) {
        var b = e.target.closest('[data-vid]');
        if (!b) return;
        onPick(Number(b.getAttribute('data-vid')));
        closePops();
      });
      document.body.appendChild(list);
      positionPop(list, anchor);

      var closeOnMove = function (e) {
        if (e && e.target && list.contains(e.target)) return;
        closePops();
      };
      window.addEventListener('scroll', closeOnMove, true);
      window.addEventListener('resize', closeOnMove);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('scroll', closeOnMove);
        window.visualViewport.addEventListener('resize', closeOnMove);
      }
      list.__gbbCleanup = function () {
        window.removeEventListener('scroll', closeOnMove, true);
        window.removeEventListener('resize', closeOnMove);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('scroll', closeOnMove);
          window.visualViewport.removeEventListener('resize', closeOnMove);
        }
        list.__gbbCleanup = null;
      };
    }
    function openColorPop(slotIdx, anchor) {
      var slot = slotIdx === 0 ? null : state.slots[state.tier][slotIdx - 1];
      var r = slotResolved(slot);
      var cur = slotIdx === 0 ? findVariant(host, readHostVid()) : r.v;
      popFor(anchor, r.p, cur.id, function (vid) {
        if (slotIdx === 0) {
          setNativeVariant(findVariant(host, vid));
          state.hostVid = vid;
        } else {
          state.slots[state.tier][slotIdx - 1] = { pid: r.p.id, vid: vid };
        }
        renderPrices(); renderSlots();
      });
    }

    /* ---------- modal ---------- */
    var modal = root.querySelector('[data-gbb-modal]');
    var modalSlot = null;
    // portal to <body>: ancestor sections carry transform/isolate (theme scroll animations),
    // which re-anchors position:fixed and traps the sheet inside the page container on phones
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);

    function productTypes() {
      var seen = {}, out = [];
      cfg.products.forEach(function (p) {
        if (p.ty && !seen[p.ty]) { seen[p.ty] = 1; out.push(p.ty); }
      });
      return out;
    }
    function filteredProducts() {
      var list = cfg.products.slice();
      if (state.filter === 'bs') list = list.filter(function (p) { return p.bs; });
      else if (state.filter !== 'all') list = list.filter(function (p) { return p.ty === state.filter; });
      if (state.sort === 'asc') list.sort(function (a, b) { return a.vs[0].p - b.vs[0].p; });
      if (state.sort === 'desc') list.sort(function (a, b) { return b.vs[0].p - a.vs[0].p; });
      return list;
    }

    function renderFilters() {
      var bar = modal.querySelector('[data-gbb-filters]');
      if (!bar) return;
      var sortLabel = state.sort === 'asc' ? '&#8593; Price: Low' : state.sort === 'desc' ? '&#8595; Price: High' : '&#8645; Price';
      var chips = '<button type="button" class="gbb-fchip gbb-fsortchip' + (state.sort ? ' on' : '') + '" data-gbb-sortcycle>' + sortLabel + (state.sort ? ' &#10005;' : '') + '</button>' +
        '<button type="button" class="gbb-fchip' + (state.filter === 'all' ? ' on' : '') + '" data-gbb-filter="all">All</button>' +
        productTypes().map(function (t) {
          return '<button type="button" class="gbb-fchip' + (state.filter === t ? ' on' : '') + '" data-gbb-filter="' + esc(t) + '">' + esc(t) + '</button>';
        }).join('');
      bar.innerHTML = chips;
    }

    function renderList() {
      var t = cfg.tiers[state.tier] || {};
      var disc = discPct();
      var list = modal.querySelector('[data-gbb-list]');
      var items = filteredProducts();
      if (!items.length) { list.innerHTML = '<div class="gbb-empty">No blasters match this filter.</div>'; return; }
      list.innerHTML = items.map(function (p) {
        var v = p.vs[0];
        var save = v.cp > v.p ? (t.save || 70) : 0;
        var first = esc((p.t.split(' ')[0] || 'THIS').toUpperCase());
        return '<div class="gbb-item" data-pid="' + p.id + '">' +
          '<img class="gbb-item-img" src="' + v.img + '" alt="" loading="lazy" decoding="async">' +
          '<div class="gbb-item-info"><span class="gbb-item-name">' + esc(p.t) +
          (p.h === 'raven' ? '<span class="gbb-item-bs">&#9733; BESTSELLER</span>' : '') +
          (demoMedia(p) ? '<span class="gbb-item-car2" aria-hidden="true">&#8964;</span>' : '') + '</span>' +
          '<span class="gbb-item-prices"><span class="gbb-item-price">' + fmt(unitPrice(v.p, disc)) + '</span>' +
          (v.cp > v.p ? '<s class="gbb-item-cmp">' + fmt(v.cp) + '</s>' : '') +
          (save > 0 ? '<span class="gbb-item-save">SAVE ' + save + '%</span>' : '') + '</span>' +
          '</div>' +
          '<div class="gbb-item-foot">' +
          (p.vs.length > 1 ? '<span class="gbb-pop"><button type="button" class="gbb-chip" data-gbb-mcolor="' + p.id + '" data-vid="' + v.id + '">' + colorChip(v, true) + '</button></span>' : '<span></span>') +
          '<button type="button" class="gbb-choose" data-gbb-pick="' + p.id + '" data-vid="' + v.id + '">CHOOSE ' + first + '</button></div></div>';
      }).join('');
      list.scrollTop = 0;
    }

    function openModal(slotIdx) {
      modalSlot = slotIdx;
      var t = cfg.tiers[state.tier] || {};
      var title = modal.querySelector('[data-gbb-modal-title]');
      if (title) title.innerHTML = 'Choose your ' + ordinal(slotIdx + 1) + ' blaster &mdash; <em>SAVE ' + (t.save || 70) + '%</em>';
      state.filter = 'all'; state.sort = '';
      renderFilters();
      renderList();
      modal.hidden = false;
      document.documentElement.classList.add('gbb-modal-open');
      modal.__gbbPrevLock = [document.documentElement.style.overflow, document.body.style.overflow];
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.hidden = true;
      modalSlot = null;
      document.documentElement.classList.remove('gbb-modal-open');
      var prev = modal.__gbbPrevLock || ['', ''];
      document.documentElement.style.overflow = prev[0];
      document.body.style.overflow = prev[1];
      closePops();
    }

    function demoMedia(p) {
      var m = (window.GBB_MEDIA || {})[p.h];
      if (m) return { kind: 'video', url: m, poster: p.vp || '' };
      if (p.vd) return { kind: 'video', url: p.vd, poster: p.vp || '' };
      return null;   // map/gallery-video only — PDP description GIFs proved cross-shuffled between
                     // products, so no fallback: no preview beats showing the WRONG blaster
    }

    function toggleExpand(card) {
      var pid = Number(card.getAttribute('data-pid'));
      var p = byId[pid];
      if (!p || !demoMedia(p)) return;
      var openX = card.querySelector('.gbb-item-x');
      // collapse everything first (also stops any playing demo video)
      [].slice.call(modal.querySelectorAll('.gbb-item-x')).forEach(function (n) { n.remove(); });
      [].slice.call(modal.querySelectorAll('.gbb-item.open')).forEach(function (n) { n.classList.remove('open'); });
      if (openX) return;                                   // it was open → now collapsed
      var dm = demoMedia(p);
      var x = document.createElement('div');
      x.className = 'gbb-item-x';
      if (dm.kind === 'video') {
        x.innerHTML = '<video src="' + dm.url + '" ' + (dm.poster ? 'poster="' + dm.poster + '" ' : '') +
          'muted autoplay loop playsinline preload="metadata"></video>';
        var vid = x.querySelector('video'); if (vid) vid.muted = true;
      } else {
        x.innerHTML = '<img src="' + dm.url + '" alt="" loading="lazy">';
      }
      card.appendChild(x);
      card.classList.add('open');
    }

    function openModalColorPop(anchor) {
      var pid = Number(anchor.getAttribute('data-gbb-mcolor'));
      var p = byId[pid];
      if (!p) return;
      var curVid = Number(anchor.getAttribute('data-vid'));
      var disc = discPct();
      popFor(anchor, p, curVid, function (vid) {
        var v = findVariant(p, vid);
        var item = anchor.closest('.gbb-item');
        anchor.setAttribute('data-vid', vid);
        anchor.innerHTML = colorChip(v, true);
        var img = item.querySelector('.gbb-item-img'); if (img) img.src = v.img;
        var pr = item.querySelector('.gbb-item-price'); if (pr) pr.textContent = fmt(unitPrice(v.p, disc));
        var cm = item.querySelector('.gbb-item-cmp'); if (cm) cm.textContent = fmt(v.cp);
        var ch = item.querySelector('[data-gbb-pick]'); if (ch) ch.setAttribute('data-vid', vid);
      });
    }

    /* ---------- events ---------- */
    function onWidgetClick(e) {
      var colorBtn = e.target.closest('[data-gbb-color]');
      if (colorBtn) { openColorPop(Number(colorBtn.getAttribute('data-gbb-color')), colorBtn); return; }

      var mcolor = e.target.closest('[data-gbb-mcolor]');
      if (mcolor) { openModalColorPop(mcolor); return; }

      var pick = e.target.closest('[data-gbb-pick]');
      if (pick) {
        var pid = Number(pick.getAttribute('data-gbb-pick'));
        var vid = Number(pick.getAttribute('data-vid'));
        if (modalSlot != null && modalSlot > 0) state.slots[state.tier][modalSlot - 1] = { pid: pid, vid: vid };
        closeModal(); renderPrices(); renderSlots();
        return;
      }

      var sortc = e.target.closest('[data-gbb-sortcycle]');
      if (sortc) {
        state.sort = state.sort === '' ? 'asc' : state.sort === 'asc' ? 'desc' : '';
        renderFilters(); renderList();
        return;
      }

      var fchip = e.target.closest('[data-gbb-filter]');
      if (fchip) {
        var fv = fchip.getAttribute('data-gbb-filter');
        state.filter = (fv === state.filter) ? 'all' : fv;   // re-tap an active chip = back to All
        renderFilters(); renderList();
        return;
      }

      var open = e.target.closest('[data-gbb-open]');
      if (open) { openModal(Number(open.getAttribute('data-gbb-open'))); return; }

      if (e.target.closest('[data-gbb-close]')) { closeModal(); return; }

      var step = e.target.closest('[data-gbb-step]');
      if (step) {
        var d = Number(step.getAttribute('data-gbb-step'));
        state.qty = Math.min(cfg.maxQty || 10, Math.max(3, state.qty + d));
        renderTier();
        return;
      }

      var card = e.target.closest('.gbb-item');
      if (card && modal.contains(card) && !e.target.closest('button') && !e.target.closest('.gbb-pop-list')) {
        toggleExpand(card);
        return;
      }

      var bar = e.target.closest('[data-gbb-bar]');
      if (bar && !e.target.closest('[data-gbb-expand]')) {
        state.tier = Number(bar.getAttribute('data-gbb-bar'));
        renderTier();
        return;
      }
    }
    root.addEventListener('click', onWidgetClick);
    modal.addEventListener('click', onWidgetClick);   // modal is portaled to <body>, clicks no longer bubble through root

    if (!window.__gbbPopCloser) {
      window.__gbbPopCloser = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.gbb-pop') && !e.target.closest('.gbb-pop-list')) {
          closePops();
        }
      });
    }

    // follow native picker changes (sticky ATC picker, bfcache, etc.)
    document.addEventListener('change', function (e) {
      var np = nativePicker();
      if (np && np.contains(e.target)) {
        setTimeout(function () { readHostVid(); renderPrices(); renderSlots(); }, 60);
      }
    });

    /* ---------- sticky ATC gating: show only after the buy box scrolls away ---------- */
    (function () {
      var target = document.querySelector('.product-form__buttons') || root;
      if (!('IntersectionObserver' in window)) { document.documentElement.classList.add('gbb-sticky-show'); return; }
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var below = entries[0].boundingClientRect.top < 0;   // buy box is ABOVE the viewport → user scrolled past it
        document.documentElement.classList.toggle('gbb-sticky-show', !visible && below);
      }, { threshold: 0 });
      io.observe(target);
    })();

    /* ---------- partial add notice (x1 2026-09-22) ----------
       When the extras add fails for good, the native replay still lands the host unit. Say so in the
       drawer (same look as the store's gift notice) instead of silently showing fewer units than picked.
       If the replay itself never opens the drawer (nothing landed), say so on the product form instead. */
    function notePartial(landed, want, form) {
      var text = 'Only ' + landed + ' of ' + want + ' blasters could be added. Please add the rest again.';
      var began = Date.now(), shown = false, poll = null;
      function stop() {
        if (poll) clearInterval(poll);
        poll = null;
        var n = document.querySelector('.gbb-partial-note');
        if (n) n.remove();
      }
      function formMessage() {
        var host = form && (form.closest('product-form') || form.parentNode);
        var wrap = host && host.querySelector('.product-form__error-message-wrapper');
        var msg = wrap && wrap.querySelector('.product-form__error-message');
        if (!msg || (!wrap.hidden && msg.textContent.trim())) return;   // keep a theme error that is already showing
        msg.textContent = 'Your bundle could not be added. Please try again.';
        wrap.hidden = false;
      }
      poll = setInterval(function () {
        var d = document.querySelector('cart-drawer');
        var open = !!(d && d.classList.contains('active'));
        if (Date.now() - began > 15000 || (shown && !open)) { stop(); return; }
        if (!shown && !open && Date.now() - began > 9000) { formMessage(); stop(); return; }
        var inner = open && d.querySelector('.drawer__inner');
        if (!inner || inner.querySelector('.gbb-partial-note')) return;
        var note = document.createElement('div');
        note.className = 'gbb-partial-note';
        note.setAttribute('role', 'alert');
        note.style.cssText = 'margin:10px 14px;padding:10px 12px;border:1px solid #f1c8c4;background:#fdf1f0;color:#9c2f27;font-size:13px;font-weight:600;border-radius:10px;line-height:1.35;';
        note.textContent = text;
        inner.insertBefore(note, inner.firstChild);
        shown = true;
      }, 250);
    }

    /* ---------- two-phase add-to-cart ---------- */
    function collectItems() {
      var items = [];
      function push(vid) {
        for (var i = 0; i < items.length; i++) if (items[i].id === vid) { items[i].quantity++; return; }
        items.push({ id: vid, quantity: 1 });
      }
      push(readHostVid());
      (state.slots[state.tier] || []).forEach(function (slot) {
        var r = slotResolved(slot); push(r.v.id);
      });
      return items;
    }

    function handleSubmit(f, e) {
      if (f.__gbbBusy) {                          // in-flight bundle add → swallow rapid double-taps
        if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
        return true;
      }
      var items = collectItems();
      var total = items.reduce(function (s, it) { return s + it.quantity; }, 0);
      var q = f.querySelector('input[name="quantity"]'); if (q) q.value = '1';
      if (total <= 1) return false;               // Buy 1 → pure native path
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      f.__gbbBusy = true;

      // native replay will add ONE host unit; we pre-add everything else
      var hostVid = readHostVid();
      var extras = [];
      items.forEach(function (it) {
        var qn = it.id === hostVid ? it.quantity - 1 : it.quantity;
        if (qn > 0) extras.push({ id: it.id, quantity: qn });
      });

      var replay = function () {
        f.__gbbPass = true;
        var btn = f.querySelector('button[name="add"], [type="submit"]');
        try { if (f.requestSubmit) f.requestSubmit(btn || undefined); else f.submit(); }
        catch (err) { try { f.requestSubmit(); } catch (e2) { f.submit(); } }
        setTimeout(function () { f.__gbbPass = false; f.__gbbBusy = false; }, 900);
      };
      if (!extras.length) { replay(); return true; }

      // Retry with backoff: Shopify 429-throttles rapid cart calls (free-ship bar /
      // chips / drawer all poll /cart.js around ATC). A 429 = NOT processed, so
      // retrying is safe — without it one throttled POST silently dropped the
      // extras and only 1 unit landed (Emi bug 2026-07-06).
      var attempt = 0;
      var picked = total;
      var doExtrasAdd = function () {
        fetch('/cart/add.js?kaching_bundles=true', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: extras })
        }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(replay)
          .catch(function (err) {
            attempt++;
            // Only a throttle (429), a 5xx or a network error is worth retrying; any other 4xx (e.g. 422) fails fast.
            var retryable = typeof err !== 'number' || err === 429 || err >= 500;
            if (retryable && attempt < 4) {                 // 700ms → 1.6s → 3.5s (~5.8s, inside the 8s spinner)
              if (window.console) console.warn('[GBB] extras add failed (try ' + attempt + ') — retrying', err);
              setTimeout(doExtrasAdd, attempt === 1 ? 700 : attempt === 2 ? 1600 : 3500);
            } else {
              if (window.console) console.warn('[GBB] extras add failed after retries — failing open with 1 unit', err);
              replay();
              notePartial(1, picked, f);
            }
          });
      };
      doExtrasAdd();
      return true;
    }

    /* ---------- init ---------- */
    (function () {
      var warm = findVariant(host, readHostVid());
      if (warm && warm.img) { var im = new Image(); im.src = warm.img; }
    })();
    renderTier();
    instances.push({ root: root, container: container, handleSubmit: handleSubmit, mainForm: mainForm });
  }

  /* ============ globals: init-all, quick-view re-injection, submit routing ============ */
  function initAll() {
    [].slice.call(document.querySelectorAll('[data-gbb]')).forEach(initWidget);
  }

  document.addEventListener('gb:quickview:ready', initAll);

  function instanceFor(f) {
    for (var i = instances.length - 1; i >= 0; i--) {
      var inst = instances[i];
      if (inst.root.isConnected && inst.container.contains(f)) return inst;
    }
    return null;
  }

  // ONE capture-phase interceptor for every instance (PDP + quick-views)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || f.getAttribute('data-type') !== 'add-to-cart-form') return;
    if (f.__gbbPass) return;                      // replay pass-through
    var inst = instanceFor(f);
    if (!inst) return;                            // no widget owns this form → native
    if (inst.mainForm() !== f) return;
    inst.handleSubmit(f, e);
  }, true);

  ready(function () {
    initAll();
    window.__gbbReady = true;
    // replay a submit the parse-time gate held while we were still loading
    var pend = window.__gbbPending;
    window.__gbbPending = null;
    if (pend && pend.form) {
      var inst = instanceFor(pend.form);
      var handled = false;
      if (inst && inst.mainForm() === pend.form) {
        handled = inst.handleSubmit(pend.form, null) === true;
      }
      if (!handled) {
        pend.form.__gbbPass = true;
        var pbtn = pend.form.querySelector('button[name="add"], [type="submit"]');
        if (pend.form.requestSubmit) pend.form.requestSubmit(pbtn || undefined); else pend.form.submit();
        setTimeout(function () { pend.form.__gbbPass = false; }, 500);
      }
    }
    // quick-add modals inject fresh widget copies after page load — bind them as they appear
    try {
      var moT = null;
      new MutationObserver(function () {
        if (moT) return;
        moT = setTimeout(function () { moT = null; initAll(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (err) {}
  });
})();
